import { __assign } from "tslib";
import memoizeOne from "memoize-one";
export function emptyFn() { }
export function falseFn() { return false; }
export function trueFn() { return true; }
export function nullFn() { return null; }
export function castInto(value, targetRange) {
    if (value > targetRange[1]) {
        return targetRange[1];
    }
    if (value < targetRange[0]) {
        return targetRange[0];
    }
    return value;
}
export function roundByStep(value, step) {
    if (value < 0) {
        return -roundByStep(-value, step);
    }
    var diff = value % step;
    if (diff < step / 2) {
        return value - diff;
    }
    else {
        return value - diff + step;
    }
}
export function canBeDivided(dividend, divisor) {
    var divideResult = dividend / divisor;
    return (divideResult >> 0) === divideResult;
}
export function createStringParamFunc(numberParamFunc) {
    return function () {
        var stringValues = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            stringValues[_i] = arguments[_i];
        }
        var numberValues = stringValues.map(function (str) { return Number(str); });
        return numberParamFunc.apply(void 0, numberValues);
    };
}
var isIEBrowser;
export function isIE() {
    if (typeof isIEBrowser === 'boolean') {
        return isIEBrowser;
    }
    var ua = navigator.userAgent;
    if (/compatible/.test(ua) && /MSIE/.test(ua)) {
        isIEBrowser = true;
    }
    else if (/Trident/.test(ua) && /rv:11\.0/.test(ua)) {
        isIEBrowser = true;
    }
    else {
        isIEBrowser = false;
    }
    return isIEBrowser;
}
export function assert(condition, errorMessage) {
    if (!condition) {
        console.error(errorMessage);
    }
}
export function inject(originalFn, additionalFn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = originalFn.apply(null, args);
        if (result !== false) {
            additionalFn();
        }
        return result;
    };
}
export function wrapWithConfigDefaults(originalFn) {
    var defaultConfig = {};
    function configDefaults(defaults) {
        defaultConfig = defaults;
    }
    var wrappedFn = function (passedConfig) {
        var config = __assign(__assign({}, defaultConfig), passedConfig);
        return originalFn(config);
    };
    wrappedFn.configDefaults = configDefaults;
    return wrappedFn;
}
export function isDom(node) {
    return node && typeof node === 'object' && node.nodeType === 1;
}
export var isBrowser = (typeof window !== 'undefined' && typeof document !== 'undefined');
export function shallowEqual(paramA, paramB) {
    if (paramA === paramB) {
        return true;
    }
    if (typeof paramA !== typeof paramB) {
        return false;
    }
    if (typeof paramA !== 'object' ||
        paramA === null ||
        typeof paramB !== 'object' ||
        paramB === null) {
        return false;
    }
    var keysOfA = Object.keys(paramA);
    var keysOfB = Object.keys(paramB);
    if (keysOfA.length !== keysOfB.length) {
        return false;
    }
    return keysOfA.every(function (key) { return paramA[key] === paramB[key]; });
}
export function createContextValueGetter() {
    return memoizeOne(function (context) { return context; }, function (newArgs, lastArgs) { return shallowEqual(newArgs[0], lastArgs[0]); });
}
